import { defineMessages } from 'react-intl';

export const messages: {
	ErrorStateHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ErrorStateMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	RefreshButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ErrorStateHeading: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.error-state.heading',
		defaultMessage: `We couldn't load hierarchy`,
		description: 'Heading displayed when the reporting lines hierarchy chart fails to load',
	},
	ErrorStateMessage: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.error-state.message',
		defaultMessage:
			'We are having some trouble loading the hierarchy chart. Wait a few moments, then try again.',
		description:
			'Message displayed when the reporting lines hierarchy chart fails to load, suggesting to try again',
	},
	RefreshButton: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.error-state.retry-button',
		defaultMessage: 'Refresh Page',
		description: 'Button to retry loading reporting lines',
	},
});
